import { gql } from '@apollo/client'

export const UploadSignature = gql`
    query UploadSignature($hash: String!) {
        uploadSignature(hash: $hash)
    }
`

export default UploadSignature
